import KT01BaseLayout from "general/components/BaseLayout/KT01BaseLayout";
import { Route, Routes } from "react-router-dom";
import InvestorReconciliationListScreen from "./screens/InvestorReconciliationListScreen";
import InvestorReconciliationDetailScreen from "./screens/InvestorReconciliationDetailScreen";

function InvestorReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route
                        path=""
                        element={
                            <InvestorReconciliationListScreen />
                        }
                    />
                    <Route path="/:reconciliationId" element={<InvestorReconciliationDetailScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default InvestorReconciliationReport;
